module.exports = __webpack_public_path__ + "img/grade-1.9d0bb63b.png";